var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',[_c('el-header',[_c('page-header')],1),_c('el-main',{class:{ 'modified-main': _vm.isPath != '/'}},[_c('router-view')],1),_c('div',{staticClass:"footer"},[_c('page-footer')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }